import buildRegistrationUrl from "../../../shared-utils/buildRegistrationUrl";

export type {
  RegistrationUrlParams,
  RegistrationUtmParams,
} from "../../../shared-utils/buildRegistrationUrl";

export default buildRegistrationUrl;
